import { render, staticRenderFns } from "./CerReciboMatriculaNewIns.vue?vue&type=template&id=05722c6c"
import script from "./CerReciboMatriculaNewIns.vue?vue&type=script&lang=js"
export * from "./CerReciboMatriculaNewIns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports